module.exports = __webpack_public_path__ + "static/media/hourse.8c799cd0.svg";